import { render, staticRenderFns } from "./AdmissionInformation.vue?vue&type=template&id=d170bdc6&scoped=true&"
import script from "./AdmissionInformation.vue?vue&type=script&lang=js&"
export * from "./AdmissionInformation.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionInformation.vue?vue&type=style&index=0&id=d170bdc6&lang=scss&scoped=true&"
import style1 from "./AdmissionInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d170bdc6",
  null
  
)

export default component.exports